<template>
  <div class="container">
    <div class="d-flex flex-column">
      <el-breadcrumb >
        <el-breadcrumb-item :to="Paths.HOMEPAGE">Trang chủ</el-breadcrumb-item>
        <el-breadcrumb-item :to="Paths.TAG_MANAGEMENT">Thư mục</el-breadcrumb-item>
        <el-breadcrumb-item>{{ tagInfo.name }}</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="d-flex flex-column">
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="6">
            <h1 class="heading_one">{{ tagInfo.name }}</h1>
          </el-col>
        </el-row>
      </div>
<!--      <div class="d-flex flex-column align-items-end">-->
<!--        <div style="margin: 5px 0 5px 0">-->
<!--          <el-dropdown v-if="selectedRowSlugs.size > 0" @command="downloadBatch">-->
<!--            <el-button type="primary" size="small"-->
<!--              ><FAIcon icon="fas fa-file-download" /> Tải xuống <b>{{ selectedRowSlugs.size }}</b> tài liệu đã chọn-->
<!--            </el-button>-->
<!--            <el-dropdown-menu slot="dropdown">-->
<!--              <el-dropdown-item command="raw" v-if="hasPermission('READ')"-->
<!--                ><i class="fas fa-file-alt mediumseagreen"></i>&nbsp; Tải file gốc-->
<!--              </el-dropdown-item>-->
<!--              <el-dropdown-item command="general_report" v-if="hasPermission('VIEW')"-->
<!--                ><i class="fas fa-chart-pie dodgerblue"></i>&nbsp; Báo cáo chi tiết-->
<!--              </el-dropdown-item>-->
<!--              <el-dropdown-item command="highlight_report" v-if="hasPermission('VIEW')"-->
<!--                ><i class="fas fa-list-alt orangered"></i>&nbsp; Báo cáo tóm tắt-->
<!--              </el-dropdown-item>-->
<!--            </el-dropdown-menu>-->
<!--          </el-dropdown>-->
<!--          <el-dropdown @command="downloadAll">-->
<!--            <el-button type="primary" size="small">-->
<!--              <FAIcon icon="fas fa-file-download" :color="Colors.WHITE" /> Tải tất cả-->
<!--            </el-button>-->
<!--            <el-dropdown-menu slot="dropdown">-->
<!--              <el-dropdown-item command="raw" v-if="hasPermission('READ')">-->
<!--                <FAIcon icon="fas fa-file-alt" />Tải file gốc-->
<!--              </el-dropdown-item>-->
<!--              <el-dropdown-item command="general_report" v-if="hasPermission('VIEW')">-->
<!--                <FAIcon icon="fas fa-chart-pie" />Báo cáo chi tiết-->
<!--              </el-dropdown-item>-->
<!--              <el-dropdown-item command="highlight_report" v-if="hasPermission('VIEW')">-->
<!--                <FAIcon class="fas fa-list-alt" />Báo cáo tóm tắt-->
<!--              </el-dropdown-item>-->
<!--            </el-dropdown-menu>-->
<!--          </el-dropdown>-->
<!--        </div>-->
<!--      </div>-->
      <div>
        <VueGoodTable
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-per-page-change="onPerPageChange"
          @on-selected-rows-change="onSelect"
          @on-search="onSearch"
          :isLoading.sync="isLoading"
          :columns="columns"
          :rows="documents"
          :row-style-class="rowStyleClassFn"
          :totalRows="totalRecords"
          :selectOptions="{
            enabled: true,
            selectOnCheckboxOnly: true,
            selectionInfoClass: 'custom-class',
            selectionText: 'tài liệu đã chọn',
            clearSelectionText: 'Bỏ chọn',
          }"
          :search-options="{
            enabled: true,
            placeholder: 'Tìm kiếm',
          }"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            rowsPerPageLabel: 'Số hàng mỗi trang',
            nextLabel: 'Trang trước',
            prevLabel: 'Trang sau',
            ofLabel: 'trong',
          }"
          styleClass="vgt-table striped bordered"
        >
          >

          <div slot="emptystate">Danh sách tài liệu của bạn đang trống</div>

          <template slot="table-row" slot-scope="props">
            <div v-if="props.column.field === 'action'" class="d-flex flex-row justify-content-around">
              <FAIcon
                icon="fas fa-file-download"
                :color="Colors.RAW"
                title="Tải tài liệu gốc"
                @click="handleDownloadDocument(props.row.slug, props.row.name, DownloadType.RAW)"
                :disabled="!hasPermission('READ') || props.row.status === DocumentState.DELETED"
              />
              <FAIcon
                icon="fas fa-chart-pie"
                @click="$refs[refs.DOCUMENT_REPORT_MODAL].showModal(props.row)"
                title="Tải báo cáo"
                :color="Colors.REPORT"
                :disabled="!hasPermission('VIEW') || props.row.status !== DocumentState.COMPLETE_PROCESS"
              />
              <FAIcon
                icon="fa fa-paper-plane"
                @click="$refs[refs.DOCUMENT_SEND_MODAL].showModal(props.row)"
                :color="Colors.SEND"
                title="Chia sẻ tài liệu"
                :disabled="!hasPermission('SHARE') || props.row.status === DocumentState.DELETED"
              />
              <el-dropdown trigger="hover" :show-timeout="0">
                <div>
                  <FAIcon icon="el-icon-more" />
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div @click="$refs[refs.DOCUMENT_INFO_MODAL].showModal(props.row)">
                      <FAIcon 
                        icon="fas fa-info-circle" 
                        :color="Colors.INFO" 
                        :disabled="props.row.status !== DocumentState.COMPLETE_PROCESS" />Thông tin
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div @click="$refs[refs.DOCUMENT_EDIT_MODAL].showModal(props.row)">
                      <FAIcon icon="fas fa-pen-nib" :color="Colors.EDIT" :disabled="props.row.status === DocumentState.DELETED"/>Chỉnh sửa
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div v-if="props.row.userAction.lastDownloadReport || props.row.userAction.lastViewWeb" @click="onResetReadAction(props.row, userMarkDocumentType.UNREAD)">
                      <FAIcon icon="fa fa-eye-slash" :color="Colors.MAIN_THEME" />Đánh dấu là chưa đọc
                    </div>
                    <div v-else @click="onResetReadAction(props.row, userMarkDocumentType.READ)">
                      <FAIcon icon="fa fa-eye" :color="Colors.MAIN_THEME" />Đánh dấu là đã đọc
                    </div>
                  </el-dropdown-item>
<!--                  <el-dropdown-item>-->
<!--                    <div @click="$refs[refs.DOCUMENT_DELETE_MODAL].showModal(props.row)">-->
<!--                      <FAIcon icon="fa fa-trash" :color="Colors.DELETE" />  Bỏ chia sẻ-->
<!--                    </div>-->
<!--                  </el-dropdown-item>-->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <span v-else-if="props.column.field === 'status'">
              <DocumentStatus :status="props.row.status" />
            </span>
            <span v-else-if="props.column.field === 'title'">
              <CommonLink
                :to="Paths.DOCUMENT_RESULT_VIEW(DocumentTypes.DOCUMENT, props.row.slug)"
                :disable="props.row.status !== DocumentState.COMPLETE_PROCESS"
              >
                {{ props.row.title }}
              </CommonLink>

              <DocumentSharingStatus
                :document="props.row"
                @click="$refs[refs.DOCUMENT_SEND_MODAL].showModal(props.row)"
              />
            </span>
          </template>

          <template slot="loadingContent">
            <span class="vgt-loading__content"> Đang tải... </span>
          </template>
        </VueGoodTable>
        <DocumentInfoModal :ref="refs.DOCUMENT_INFO_MODAL" />
        <DocumentEditModal :ref="refs.DOCUMENT_EDIT_MODAL" @success="loadItems" />
        <DocumentDeleteModal :ref="refs.DOCUMENT_DELETE_MODAL" @success="loadItems" />
        <DocumentSendModal :ref="refs.DOCUMENT_SEND_MODAL" @success="loadItems" />
        <DocumentReportModal :ref="refs.DOCUMENT_REPORT_MODAL" @success="loadItems" />
      </div>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import {
  apiDownloadALlDocumentInTag,
  apiDownloadBatchDocument,
  apiDownloadDocumentAsArrayBuffer,
  apiGetAllDocumentByTag, apiMarkDocumentAsRead, apiResetDocumentAction, apiUpdateGroupDocument
} from '@/services/document_management_service'
import { ComponentType, DocumentState, DownloadType, Table } from '@/constants/DoITConstant'
import { pushArraybuffer2Client } from '@/helpers/DownloadHelper'
import truncate from 'vue-truncate-collapsed'
import { getTagInfo } from '@/services/tag_management_service'
import { Paths } from '@/routes/paths.js'
import FAIcon from '@/components/common/FAIcon.vue'
import DocumentEditModal from '@/components/DocumentManagement/action-modals/DocumentEditModal.vue'
import DocumentDeleteModal from '@/components/DocumentManagement/action-modals/DocumentDeleteModal.vue'
import DocumentSendModal from '@/components/DocumentManagement/action-modals/DocumentSendModal.vue'
import DocumentInfoModal from '@/components/DocumentManagement/action-modals/DocumentInfoModal.vue'
import DocumentCheckModal from '@/components/DocumentManagement/action-modals/DocumentCheckModal.vue'
import DocumentReportModal from '@/components/DocumentManagement/action-modals/DocumentReportModal.vue'
import { Colors, DocumentTypes } from '@/constants/DoITConstant.js'
import { formatDateTime } from '@/helpers/timeHelper.js'
import DocumentStatus from '@/components/common/document/DocumentStatus.vue'
import DocumentSharingStatus from '@/components/common/document/DocumentSharingStatus.vue'
import CommonLink from '@/components/common/CommonLink.vue'

export default {
  name: 'UserTagDocumentView',
  components: {
    CommonLink,
    DocumentSharingStatus,
    DocumentStatus,
    DocumentReportModal,
    DocumentCheckModal,
    DocumentInfoModal,
    DocumentSendModal,
    DocumentDeleteModal,
    DocumentEditModal,
    VueGoodTable,
    truncate,
    FAIcon,
  },
  props: {},
  data: function() {
    return {
      columns: [],
      componentType: ComponentType.DOCUMENT,
      tagInfo: {},
      DownloadType: DownloadType,
      totalRecords: 0,
      DocumentState,
      serverParams: {
        sortAscending: false,
        sortField: 'sharingTime',
        page: 0,
        size: 10,
      },
      selectedRowSlugs: [],
      documents: [],
      interval: null,
      isLoading: true,
      Paths,
      Colors,
      DocumentTypes,
      userMarkDocumentType: {
        READ: 'READ',
        UNREAD: 'UNREAD'
      },
      refs: {
        DOCUMENT_INFO_MODAL: 'documentInfoModal',
        DOCUMENT_EDIT_MODAL: 'documentEditModal',
        DOCUMENT_DELETE_MODAL: 'documentDeleteModal',
        DOCUMENT_SEND_MODAL: 'documentSendModal',
        DOCUMENT_CHECK_MODAL: 'documentCheckModal',
        DOCUMENT_REPORT_MODAL: 'documentReportModal',
      },
    }
  },
  async mounted() {
    let resInfo = await getTagInfo(this.$route.params.id)
    if (resInfo == null) {
      this.$message.error('Có lỗi xảy ra')
      setTimeout(() => this.$router.go(-1), 2000)
    } else {
      this.tagInfo = resInfo
    }

    this.columns = [
      {
        label: 'ID',
        field: 'id',
      },
      {
        label: 'Tiêu đề',
        field: 'title',
      },
      {
        label: 'Độ trùng lặp',
        field: 'score',
        formatFn: (score) => (score !== null ? `${score} %` : ''),
      },
      {
        label: 'Lỗi chính tả',
        field: 'spellError',
      },
      {
        label: 'Ngày chia sẻ',
        field: 'sharingTime',
        formatFn: formatDateTime,
      },
      {
        label: 'Ngày tải lên',
        field: 'uploadTime',
        formatFn: formatDateTime,
      },
      {
        label: 'Trạng thái',
        field: 'status',
      },
      {
        label: 'Hành động',
        field: 'action',
      },
    ]
    this.loadItems().then()
    this.interval = setInterval(() => {
      if (this.selectedRows.length === 0) {
        this.loadItems()
      }
    }, Table.RELOAD_INTERVAL)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    rowStyleClassFn(row) {
      const userAction = row.userAction
      return userAction.lastDownloadReport || userAction.lastViewWeb ? 'read-document' : 'unread-document'
    },
    hasPermission(permission) {
      return this.tagInfo.permissions && this.tagInfo.permissions.includes(permission)
    },
    async handleDownloadDocument(slug, name, type) {
      let res = await apiDownloadDocumentAsArrayBuffer(slug, type)
      pushArraybuffer2Client(res, name)
    },
    onResetReadAction(row, type) {
      let updateFunc = apiResetDocumentAction
      let message = 'Đã đánh dấu tài liệu là chưa đọc'
      if (type === this.userMarkDocumentType.READ) {
        updateFunc = apiMarkDocumentAsRead
        message = 'Đã đánh dấu tài liệu là đã đọc'
      }

      updateFunc(row.slug)
        .then(() => {
          this.$message.success(message)
          this.loadItems()
        })
        .catch(() => {
          this.$message.error('Có lỗi xảy ra')
        })
    },
    onSearch(params) {
      this.serverParams.searchKey = params.searchTerm
      this.loadItems()
    },

    onPageChange(params) {
      this.serverParams.page = params.currentPage - 1
      this.loadItems()
    },

    onPerPageChange(params) {
      this.serverParams.size = params.currentPerPage
      this.loadItems()
    },

    onSortChange(params) {
      this.serverParams.sortAscending = params[0].type === 'asc'
      this.serverParams.sortField = params[0].field
      this.serverParams.page = 0
      this.loadItems()
    },
    async loadItems() {
      this.isLoading = true
      let responseAllDocument = await apiGetAllDocumentByTag(this.$route.params.id, this.serverParams)
      this.documents = responseAllDocument.data
      this.totalRecords = responseAllDocument.meta.total
      this.isLoading = false
    },
    onSelect(params) {
      this.selectedRowSlugs = new Set()
      params.selectedRows.forEach((row) => this.selectedRowSlugs.add(row.slug))
    },
    async downloadBatch(type) {
      if (this.selectedRowSlugs.size === 0) return
      const loading = this.$loading({
        lock: true,
        text: 'Đang tải tài liệu',
        spinner: 'el-icon-loading',
      })
      let res = await apiDownloadBatchDocument(this.selectedRowSlugs, type)
      pushArraybuffer2Client(res, 'selected_' + new Date().getTime() + type + '.zip')
      loading.close()
    },

    async downloadAll(type) {
      let res = await apiDownloadALlDocumentInTag(this.tagInfo.id, type)
      pushArraybuffer2Client(res, 'all_' + this.tagInfo.id + new Date().getTime() + type + '.zip')
    },
  },
}

</script>

<style>
.unread-document {
  background-color: rgba(0, 0, 0, 0.05) !important;
  -webkit-box-shadow: 2px 2px 4px -3px #0000;
  box-shadow: 2px 2px 4px -3px #0000;
}
.read-document {
  background-color: transparent !important;
}
</style>
